export const ADDRESS_FIELD_LABEL = 'Enter an address';
export const STREET_NAME_NUMBER_REGEX = /^\s*([0-9-]+)\s+(.+)/i;
export const GOOGLE_ADDRESS_PARTS = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    administrative_area_level_2: 'short_name',
    sublocality_level_1: 'long_name',
    administrative_area_level_3: 'long_name',
    sublocality: 'long_name',
    neighborhood: 'long_name',
    administrative_area_level_4: 'long_name',
    administrative_area_level_5: 'long_name',
    administrative_area_level_6: 'long_name',
    administrative_area_level_7: 'long_name',
    country: 'short_name',
    postal_code: 'short_name',
    subpremise: 'short_name',
};
export const MAP_GOOGLE_PROPS_TO_FORM_PROPS = {
    street_number: 'street_number',
    route: 'street_name',
    locality: 'municipality',
    administrative_area_level_1: 'country_primary_subdivision',
    administrative_area_level_2: 'country_secondary_subdivision',
    sublocality_level_1: 'municipality',
    administrative_area_level_3: 'municipality',
    sublocality: 'municipality',
    neighborhood: 'municipality',
    administrative_area_level_4: 'municipality',
    administrative_area_level_5: 'municipality',
    administrative_area_level_6: 'municipality',
    administrative_area_level_7: 'municipality',
    country: 'country_code',
    postal_code: 'postal_code',
    coordinates: 'coordinates',
    subpremise: 'street_unit',
};
export const MAP_FORM_PROPS_TO_GOOGLE_PROPS = {
    street_number: 'street_number',
    street_name: 'route',
    municipality: [
        'locality',
        'sublocality',
        'sublocality_level_1',
        'administrative_area_level_3',
        'neighborhood',
        'administrative_area_level_4',
        'administrative_area_level_5',
        'administrative_area_level_6',
        'administrative_area_level_7',
    ],
    country_primary_subdivision: 'administrative_area_level_1',
    country_secondary_subdivision: 'administrative_area_level_2',
    country_code: 'country',
    postal_code: 'postal_code',
    street_unit: 'subpremise',
};
//# sourceMappingURL=constants.js.map